import { Component, Input } from '@angular/core';
import { Exercice } from '../../model/exercice.model';
import { ExerciceService } from '../../service/exercice.service';

@Component({
  selector: 'app-exercice-preview',
  templateUrl: './exercice-preview.component.html',
  styleUrls: ['./exercice-preview.component.scss']
})
export class ExercicePreviewComponent {
  @Input() exercice: Exercice;

  constructor(public exerciceService: ExerciceService) { }
}
